import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import {
    Chart,
    LineElement,
    PointElement,
    LineController,
    LinearScale,
    TimeScale,
    Legend,
    Tooltip
} from 'chart.js';

import 'chartjs-adapter-moment';

Chart.register(
    LineElement,
    PointElement,
    LineController,
    LinearScale,
    TimeScale,
    Legend,
    Tooltip
);

export default {
    render: (container, chart_data) => {
        var colours = ['#2878f0', '#7828f0', '#F0A028', '#00C878', '#4C545B', '#E80000', '#FF5722', '#00BCD4'];

        var series_data = [];
        var count = 0;

        _.each(chart_data.data, function(data, index) {
            if (count >= colours.length) {
                count = 0;
            }

            var highest = 0;
            _.each(data, function(num) {
                highest = Math.max(highest, num);
            });

            var zindex = Math.max(1, 1000000 - highest);
            var workflow = Cache.workflow.findWhere({name: index});
            var colour = workflow ? workflow.get('colour') : colours[count];

            series_data.push({
                label: index,
                data: data,
                order: zindex,
                tension: 0.5,
                borderWidth: 2,
                backgroundColor: colour,
                borderColor: colour,
                pointHitRadius: 8,
                pointRadius: 0,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 4,
                pointHoverBackgroundColor: '#FFFFFF'
            });

            count++;
        });

        container.empty();

        var canvas = $('<canvas>').appendTo(container);

        var app_font = $(document.body).css('font-family');

        Chart.defaults.font.family = app_font;

        var chart = new Chart(canvas.get(0), {
            type: 'line',
            data: {
                labels: chart_data.labels,
                datasets: series_data
            },
            options: {
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            tooltipFormat: 'MMMM DD, YYYY',
                            stepSize: Math.max(1, Math.round(chart_data.labels.length / 16))
                        },
                        grid: {
                            display: false
                        }
                    },
                    y: {
                        min: 0
                    }
                },
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            padding: 20,
                            usePointStyle: true,
                            pointStyle: 'line'
                        }
                    },
                    tooltip: {
                        backgroundColor: '#222D39',
                        titleMarginBottom: 4,
                        padding: 12,
                        displayColors: false
                    }
                }
            }
        });
    }
};